import './meta-box.scss';
import MetaBox from "./components/MetaBox";
import icons from "./components/Icons";


(function (wp, React) {
    wp.domReady( function() {
        wp.plugins.registerPlugin('pushly', {
            icon: icons.pushly,
            render: MetaBox,
        });
    });
})(window.wp, window.React);
